import { render, staticRenderFns } from "./LeadViewRight.vue?vue&type=template&id=f2201ccc&scoped=true&"
import script from "./LeadViewRight.vue?vue&type=script&lang=js&"
export * from "./LeadViewRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2201ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2201ccc')) {
      api.createRecord('f2201ccc', component.options)
    } else {
      api.reload('f2201ccc', component.options)
    }
    module.hot.accept("./LeadViewRight.vue?vue&type=template&id=f2201ccc&scoped=true&", function () {
      api.rerender('f2201ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/partials/LeadViewRight.vue"
export default component.exports